import api from "./axiosConfig";
import { AiPerformance, DashboardReport, DisputeOutcomes, RevenueReport, ScoreHistoryPoint } from "../types";

export interface ReportsStatusCount {
  status: string;
  count: number;
}

export interface ReportsBureauStat {
  bureau: string;
  total: number;
  resolved: number;
  inDispute: number;
}

export interface MonthlyActivity {
  month: string;
  lettersSent: number;
  newClients: number;
  itemsResolved: number;
}

export interface ReportsDashboardAnalytics {
  totalClients: number;
  activeDisputes: number;
  resolvedDisputes: number;
  awaitingResponse: number;
  totalDisputeItems: number;
  resolutionRate: number;
  averageScoreChange: number;
  estimatedMonthlyRevenue: number;
  revenuePerClient: number;
  statusBreakdown: ReportsStatusCount[];
  bureauStats: ReportsBureauStat[];
  monthlyActivity: MonthlyActivity[];
  averageScoreTrend: { label: string; value: number }[];
}

export interface ClientOutcomeRow {
  clientId: string;
  clientName: string;
  scoreImprovement?: number | null;
  averageDaysToResolution?: number | null;
  totalDisputes: number;
  resolvedDisputes: number;
}

export const reportsApi = {
  /** Primary analytics dashboard (real tenant data). */
  getReportsDashboard: async (rangeDays: number): Promise<ReportsDashboardAnalytics> => {
    const response = await api.get<ReportsDashboardAnalytics>("/reports", { params: { rangeDays } });
    return response.data;
  },

  getReportsDisputes: async (): Promise<unknown> => {
    const response = await api.get("/reports/disputes");
    return response.data;
  },

  getReportsClients: async (): Promise<ClientOutcomeRow[]> => {
    const response = await api.get<ClientOutcomeRow[]>("/reports/clients");
    return response.data;
  },

  getReportsActivity: async (): Promise<MonthlyActivity[]> => {
    const response = await api.get<MonthlyActivity[]>("/reports/activity");
    return response.data;
  },

  getDashboard: async (rangeDays: number): Promise<DashboardReport> => {
    const response = await api.get<DashboardReport>("/reports/dashboard", { params: { rangeDays } });
    return response.data;
  },

  getClientScoreHistory: async (clientId: string, rangeDays: number): Promise<ScoreHistoryPoint[]> => {
    const response = await api.get<ScoreHistoryPoint[]>(`/reports/client/${clientId}/score-history`, {
      params: { rangeDays },
    });
    return response.data;
  },

  getDisputeOutcomes: async (rangeDays: number): Promise<DisputeOutcomes> => {
    const response = await api.get<DisputeOutcomes>("/reports/dispute-outcomes", { params: { rangeDays } });
    return response.data;
  },

  getAiPerformance: async (rangeDays: number): Promise<AiPerformance> => {
    const response = await api.get<AiPerformance>("/reports/ai-performance", { params: { rangeDays } });
    return response.data;
  },

  getRevenue: async (rangeDays: number): Promise<RevenueReport> => {
    const response = await api.get<RevenueReport>("/reports/revenue", { params: { rangeDays } });
    return response.data;
  },
};
